import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DocumentlibraryConstantsService {

  constructor() { }

  public static DLGetURL = {
    uploadDocument: 'api/dl/post/UploadDocumentDetails',
    getLibraryDetails: 'api/dl/get/getDocumentDetails',
    getFileTypeDetails: 'api/dl/get/getFileTypeDetails',
    downloadZIP: 'api/dl/get/downloadZIP',
    deleteDocument: 'api/dl/delete/document',
    revertDocument: 'api/dl/get/revertDocument',
    RenameDocument: 'api/dl/post/RenameDocument',

  };

  public static DLNavigation: any = {
    Routes: [
      {
        routeName: 'Home',
        routeURL: '../../home',
        isClickable: true
      },
      {
        routeName: 'Document Library',
        routeURL: '/dl/document-library/',
        isClickable: true
      }
    ],
    InnerRoutes: [
      {
        routeName: 'Home',
        routeURL: '../../home',
        isClickable: true
      },
      {
        routeName: 'Document Library',
        routeURL: '/dl/document-library/',
        isClickable: true
      }
    ],
    ReportRoutes: []
  };
}
export enum DocumentType {
  Folder = 1,
  File
}

